

export const Leaderboard = [
  {
    name: "Ezekiel Kofi Asigbey",
    class: "HND COMPUTER SCIENCE, L200",
    score: "NA",
    img: "", // Use the imported image
    dt: "2023-07-01",
  },
  
    {
      name: "Emmanuel Tokoli",
      class: "HND COMPUTER SCIENCE, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Seth Kpotor Mawunya ",
      class: "HND COMPUTER SCIENCE, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Joseph Ahiakor",
      class: "HND COMPUTER SCIENCE, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Enoch Kwame",
      class: "HND ICT, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Nubor Kwame Eric",
      class: "HND ICT, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Akoto Ernest",
      class: "BTECH ICT, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Gati Godshand",
      class: "HND ICT, L100",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    },
  
    {
      name: "Samuel Atsyatsya",
      class: "BTECH ICT, L200",
      score: "NA",
      img: "",
      dt: "2023-07-01"
    }
  ];
  